import type { QueryKey } from '@tanstack/react-query';
import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import type { CommandPaletteSearchResponse } from '../../../../shared/CommandPalette/types';

/**
 * Search for projects and release groups via the command palette.
 */
function searchCommandPalette(searchTerm: string) {
  return get<CommandPaletteSearchResponse>(`/api/command-palette/search/${searchTerm}`, true);
}

//  Ensures that the query key is unique for each search term.
const getQueryKey = (searchTerm: string): QueryKey => ['command-palette', 'search', searchTerm];

/**
 * Hook for searching for projects and release groups via the command palette.
 */
export default function useCommandPaletteSearch(searchTerm: string, shouldFetch: boolean = false) {
  return useQuery<CommandPaletteSearchResponse>({
    queryFn: () => searchCommandPalette(searchTerm),
    queryKey: getQueryKey(searchTerm),
    enabled: shouldFetch,
  });
}
